import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

import filterObject from 'utils/filter-object';

export default function useSearchParams() {
    const history = useHistory();
    const location = useLocation();

    const searchParams = useMemo(() => Object.fromEntries(new URLSearchParams(location.search)), [location.search]);

    const setSearchParams = useCallback(
        (searchParams) =>
            history.push({
                search: new URLSearchParams(filterObject(searchParams)).toString()
            }),
        [history]
    );

    /** @type {[Record<string, string>, (params: Record<string, string | number>) => void]} */
    const output = [searchParams, setSearchParams];
    return output;
}
